import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=376412bc&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=376412bc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376412bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('376412bc')) {
      api.createRecord('376412bc', component.options)
    } else {
      api.reload('376412bc', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=376412bc&scoped=true", function () {
      api.rerender('376412bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/detail.vue"
export default component.exports